import * as React from "react";
import { merge, $ } from "glamor";
import theme from "styles/theme";
import { formatMessage } from "lib/globalize-util";
import { CellValueChangedEvent } from "ag-grid-community";

const styles = merge(
    {
        textAlign: "right",
        fontFamily: "Lato !important",
    },
    $(" .pinnedCell", {
        textAlign: "right",
    }),
    $(" .text", {
        height: "18px",
        display: "block",
        fontSize: "11px",
        fontWeight: "bolder",
    }),
    $(" .quantity", {
        fontSize: "12px",
        height: "18px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.5",
        letterSpacing: "0.16px",
        textAlign: "right",
        color: theme.palette.darkerGrey,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),
    $(" .totalPrice", {
        fontSize: "12px",
        height: "18px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.5",
        letterSpacing: "0.16px",
        textAlign: "right",
        color: theme.palette.darkerGrey,
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),
    $(" .totalRetail", {
        fontSize: "9px",
        height: "16px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.78",
        letterSpacing: "0.12px",
        textAlign: "right",
        color: "#585858",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        marginBottom: "8px",
    }),
);

export const PinnedFooterRowRenderer = (props: CellValueChangedEvent) => {
    const { column, data } = props;
    const colId = column.getColId();
    const formatter = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
    });

    if (!data) {
        return <span className="pinnedCell" />;
    }
    if (colId === "ag-Grid-AutoColumn") {
        return (
            <div {...styles} className="pinnedCell">
                <div className="quantity">{formatMessage("Total Units")}</div>
                <div className="totalPrice"> {formatMessage("Total Wholesale")} </div>
                <div className="totalRetail">{formatMessage("Total MSRP")}</div>
            </div>
        );
    }

    return (
        <div {...styles} className="pinnedCell">
            <div className="quantity">{data[colId]?.quantity}</div>
            <div className="totalPrice">
                {data[colId]?.currency?.wholesale?.symbol}
                {formatter.format(data[colId]?.totalWholesalePrice)}
            </div>
            <div className="totalRetail">
                {data[colId]?.currency?.retail?.symbol}
                {formatter.format(data[colId]?.totalRetailPrice)}
            </div>
        </div>
    );
};
